import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';

export const transactionsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'date',
    label: 'Date & time',
  },
  {
    name: 'description',
    label: 'Description',
  },
  {
    name: 'currency',
    label: 'Currency',
  },
  {
    name: 'amount',
    label: 'Amount',
  },
  {
    name: 'amountBc',
    label: 'Amount BC',
  },
  {
    name: 'merchantName',
    label: 'Merchant name',
    filterModalPlacement: 'right',
  },
  {
    name: 'terminalId',
    label: 'Terminal ID',
    filterModalPlacement: 'right',
  },
  {
    name: 'orderDetails',
    label: 'Order details',
    filterModalPlacement: 'right',
  },
];

export const transactionsDefaultSorter = {
  sortProp: transactionsColumns[0].name,
  sortDir: SortDir.ASC,
};

export const transactionsSchema = {
  date: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['dateFrom', 'dateTo'],
  },
  dateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  dateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  description: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currency: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  amount: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  amountBc: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  orderDetails: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  merchantName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  terminalId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, transactionsDefaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, transactionsDefaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const transactionsColumnsLabels = {
  date: 'Date & time',
  dateFrom: 'Date From',
  dateTo: 'Date To',
  description: 'Description',
  currency: 'Currency',
  amount: 'Amount',
  amountBc: 'Amount B',
  merchantName: 'Merchant Name',
  orderDetails: 'Order Details',
  terminalId: 'Terminal ID',
  sort: 'Sort name',
  sortDir: 'Sort direction',
};

export const transactionsFiltersSchema = [
  {
    name: 'date',
    type: FilterType.DATE_RANGE,
  },
  {
    name: 'description',
    type: FilterType.TEXT,
    placeholder: 'Enter description...',
  },
  {
    name: 'currency',
    type: FilterType.RADIO,
    fields: [
      {
        title: 'EUR',
        value: 'eur',
      },
      {
        title: 'USD',
        value: 'usd',
      },
      {
        title: 'JPY',
        value: 'jpy',
      },
    ],
  },
  {
    name: 'merchantName',
    type: FilterType.TEXT,
    placeholder: 'Enter merchant name...',
  },
  {
    name: 'amount',
    type: FilterType.TEXT,
    placeholder: 'Enter amount sum...',
  },
  {
    name: 'amountBc',
    type: FilterType.TEXT,
    placeholder: 'Enter amount sum...',
  },
  {
    name: 'terminalId',
    type: FilterType.TEXT,
    placeholder: 'Enter terminal ID...',
  },
  {
    name: 'orderDetails',
    type: FilterType.TEXT,
    placeholder: 'Enter text...',
  },
];
